import TaskTable from '../../../../../components/daily-care-log/task-table/task-table';
import {CareTaskComplementary} from '../../../../../backend/interfaces/care-task-complementary';
import {EntitySocialResponse} from '../../../../../backend/interfaces/entity-social-response';
import {EntityUser} from '../../../../../backend/responses/entity-user';
import {useParams} from 'react-router-dom';

interface SimpleShiftTabViewProps {
  tasks?: CareTaskComplementary[];
  seniors?: Map<string, EntityUser>;
  entitySocialResponses?: EntitySocialResponse[];
}

export const SimpleShiftTabView = ({
  tasks,
  seniors,
  entitySocialResponses,
}: SimpleShiftTabViewProps) => {
  let {entityShiftId, date}: {entityShiftId: string; date: string} = useParams();
  return (
    <TaskTable
      tasks={tasks}
      seniors={seniors}
      entitySocialResponses={entitySocialResponses}
      entityShiftId={entityShiftId}
      date={date}
    />
  );
};
